<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button
          class="btn btn-fill btn-icon"
          @click="minimizeSidebar"
        >
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          :class="{toggled: $sidebar.showSidebar}"
          @click="toggleSidebar"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{this.$route.meta.title}} <ProjectName/></a>
      </div>
      <div class="collapse navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <drop-down
            tag="li"
            :title="user.name"
            icon="ti-user"
          >
            <li><a
              href="#"
              @click.prevent="logout()"
            ><i class="ti-shift-right"></i> Sair</a></li>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import ProjectName from '../../../components/ProjectName'
  import AuthService from './../../../services/AuthService'
  import {mapGetters} from 'vuex'

  export default {
    name: 'TopNavbar',
    components: {
      ProjectName
    },
    data () {
      return {
        activeNotifications: true
      }
    },
    computed: {
      ...mapGetters(['user'])
    },
    methods: {
      logout () {
        AuthService.logout()
        this.$router.push('/login')
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue